import React, { Component } from "react";
import {
  Row,
  Col,
  Image,
  Button,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import StarRatings from "react-star-ratings";
import _ from "lodash";

import LinesEllipsis from "react-lines-ellipsis";

// Helper
import {
  _renderRestaurantProfilePic,
  _renderCloseTime,
} from "../../helpers/Utility";

import Icon from "./../Icon";
import Color from "./../../assets/color";

import PropTypes from "prop-types";

import RestaurantStyle from "./style";

class RestaurantListing extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  imageOnError = (event) => {
    event.target.setAttribute(
      "src",
      require("./../../assets/img/lolol-bg-white.png")
    );
  };

  getDeliveryFeeDiscount = (item) => {
    // let deliveryDiscount = delivery_discount;
    let deliveryDiscount = _.reverse(
      _.sortBy(item, (spendRow) => parseFloat(spendRow.spend))
    );
    return deliveryDiscount[0].cash
      ? "RM " + deliveryDiscount[0].cash
      : deliveryDiscount[0].discount
      ? deliveryDiscount[0].discount + "%"
      : "-";
  };
  _renderDeliveryDiscount = (restaurantDeliveryDiscount) => {
    // Sort according by spend
    restaurantDeliveryDiscount = _.sortBy(
      restaurantDeliveryDiscount,
      (spendRow) => parseFloat(spendRow.spend)
    );

    return restaurantDeliveryDiscount.map((discountRow, index) => (
      <p className="mb-0" key={index}>
        Above RM {discountRow.spend}, delivery fee discount{" "}
        {discountRow.discount
          ? discountRow.discount + "%"
          : "RM " + discountRow.cash}
      </p>
    ));
  };
  render() {
    const {
      restaurant,
      restaurantIndex,
      totalRestaurant,
      updateCartAddress,
    } = this.props;
    /* Food Preference String */
    let restaurantFoodPreference = ["halal", "vegetarian", "pork_free"];
    // let restaurantFoodPreferenceString = ["Halal", "Vegetarian", "No Pork"];
    let restaurantFoodPreferenceString = [
      "Halal",
      "Vegetarian",
      "Muslim Friendly",
    ];

    let countFoodPreference = 0;
    let foodPreferenceString = "";
    restaurantFoodPreference.forEach((type, index) => {
      if (restaurant.RestaurantSetting[type] === true) {
        foodPreferenceString +=
          countFoodPreference > 0
            ? " / " + restaurantFoodPreferenceString[index]
            : restaurantFoodPreferenceString[index];
        countFoodPreference++;
      }
    });
    /* END Food Preference String */

    /* Restaurant Features Output */
    let restaurantFeatures = [
      "delivery",
      "dine_in",
      "pick_up",
      "table_reserve",
      "snp",
    ];
    let restaurantFeaturesIcon = [
      "delivery",
      "dinein",
      "pickup",
      "reservation",
      "pay",
    ];
    let restaurantFeaturesLabel = [
      "Delivery",
      "Dine In",
      "Pick Up",
      "Reservation",
      "Scan & Pay",
    ];

    let countRestaurantFeatures = 0;
    let restaurantFeaturesOutput = [];
    restaurantFeatures.forEach((feature, index) => {
      if (restaurant.RestaurantSetting[feature] === true) {
        restaurantFeaturesOutput.push(
          <OverlayTrigger
            key={index}
            placement="top"
            overlay={
              <Tooltip id={`tooltip-${feature}`}>
                {restaurantFeaturesLabel[index]}
              </Tooltip>
            }
          >
            <div className={countRestaurantFeatures > 0 ? "ml-2" : ""}>
              <Icon
                type="custom"
                name={restaurantFeaturesIcon[index]}
                color={Color.black}
                size={15}
              />
            </div>
          </OverlayTrigger>
        );

        countRestaurantFeatures++;
      }
    });
    /* END Restaurant Features Output */

    return (
      <RestaurantStyle>
        <div
          className={`${
            restaurantIndex + 1 === totalRestaurant
              ? "mb-3"
              : restaurantIndex === 0
              ? "mt-3"
              : ""
          } restaurant-listing mx-4 mx-md-5 mx-lg-4 mx-xl-5`}
        >
          <div
            className={
              restaurantIndex > 0
                ? "mt-3 p-3 pr-md-4 pr-lg-3"
                : "p-3 pr-md-4 pr-lg-3"
            }
          >
            <Row className="w-100 m-0">
              <Col md={3} lg={3} className="p-0 d-flex flex-md-column">
                <Col className="restaurant-image mx-md-auto my-auto flex-grow-0 flex-shrink-0 p-0">
                  <Image
                    className="w-100 h-100 position-absolute"
                    src={_renderRestaurantProfilePic(restaurant.Media)}
                    onError={this.imageOnError}
                  />
                </Col>
                <div className="ml-auto ml-md-0 mt-auto d-flex flex-column">
                  <StarRatings
                    rating={JSON.parse(restaurant.avg_rating)}
                    starRatedColor={Color.primary}
                    starEmptyColor={Color.athens}
                    starDimension="15px"
                    starSpacing="1px"
                  />

                  <span className="restaurant-number-of-review p-lg-0 ml-auto mx-md-auto">
                    {restaurant.total_vote} Reviews
                  </span>
                </div>
              </Col>
              <Col md={9} lg={9} className="p-0 pl-lg-3">
                <Row className="w-100 m-0 p-0 d-flex">
                  <Col className="p-0 mt-2 mt-md-0 flex-grow-1">
                    <h3 className="mb-0">
                      <LinesEllipsis
                        text={restaurant.restaurant_name}
                        maxLine="2"
                        ellipsis="..."
                        basedOn="letters"
                      />
                    </h3>
                    <p className="mb-0 restaurant-preferences-text">
                      <i>{foodPreferenceString}</i>
                    </p>
                    <p className="mt-1 mb-0">
                      {restaurant.isNewRestaurant === 1 ? (
                        <span style={{ color: "#03a9f4" }}>{"New"}</span>
                      ) : null}
                      {restaurant.isNewRestaurant === 1 ? (
                        <span>{", "}</span>
                      ) : null}
                      {restaurant.openNow === 1 ? (
                        <span className="text-success">Open Now</span>
                      ) : restaurant.RestaurantSetting.preorder === true &&
                        restaurant.RestaurantSetting.preorder_now !== true ? (
                        <span className="text-success">Open Now</span>
                      ) : (
                        <span className="text-danger">
                          {_renderCloseTime(restaurant)}
                        </span>
                      )}

                      {restaurant.RestaurantSetting ? (
                        restaurant.RestaurantSetting.preorder === true ? (
                          <span>, Allowed Pre-Order</span>
                        ) : (
                          ""
                        )
                      ) : null}
                    </p>
                    <div className="d-flex my-2">
                      {restaurantFeaturesOutput}
                    </div>
                    <div className="d-flex">
                      <p>Delivery Fee: </p>
                      <p className="delivery-fee ml-2">
                        <b>
                          {this.props.calculateDeliveryFee(restaurant.distance)}
                        </b>
                      </p>
                    </div>
                    {restaurant.RestaurantSetting.delivery_discount !==
                      null && (
                      <div
                        className="d-flex"
                        style={{ marginTop: -10, marginBottom: -5 }}
                      >
                        <p>
                          Delivery Fee discount up to{" "}
                          <b>
                            {this.getDeliveryFeeDiscount(
                              restaurant.RestaurantSetting.delivery_discount
                            )}
                          </b>
                        </p>
                      </div>
                    )}
                  </Col>
                  <Col className="p-0 d-flex flex-grow-0">
                    <div className="distance-tag d-flex flex-column justify-content-center rounded-circle text-center ml-auto my-auto my-md-auto">
                      <h3 className="m-0">
                        {restaurant.distance
                          ? restaurant.distance.toFixed(1)
                          : "0.0"}
                      </h3>
                      <span>km</span>
                    </div>
                  </Col>
                </Row>
                <Col className="d-flex justify-content-between p-0 ">
                  <Button
                    className="py-2 flex-fill"
                    variant="primary"
                    onClick={() => {
                      updateCartAddress(restaurant.restaurant_id);
                    }}
                  >
                    <b>Order Now</b>
                  </Button>
                  <Button
                    className="ml-3 py-2 flex-fill"
                    variant="light"
                    onClick={
                      this.props.viewOnMap
                        ? () =>
                            this.props.viewOnMap(
                              restaurant.restaurant_id,
                              restaurant.restaurant_latitude,
                              restaurant.restaurant_longitude
                            )
                        : null
                    }
                  >
                    <b>View on Map</b>
                  </Button>
                </Col>
              </Col>
            </Row>
          </div>
        </div>
      </RestaurantStyle>
    );
  }
}

RestaurantListing.propTypes = {
  restaurant: PropTypes.object.isRequired,
};

export default RestaurantListing;
